/**
 * Histórico do processo (TB02130) — stepper horizontal para modal V2.
 * Esquerda = mais antigo; direita = etapa atual.
 */

import React, { useState } from 'react';
import { formatReincidenciaDataAbertura } from '../utils/orderDetailsReincidenciaUtils';

function HistoricoStepDot({ isCurrent }) {
  if (isCurrent) {
    return <span className="odv2-historico-dot odv2-historico-dot--current" aria-hidden />;
  }
  return <span className="odv2-historico-dot odv2-historico-dot--past" aria-hidden />;
}

export function OrderDetailsHistoricoProcessoV2({ steps, loading, error }) {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const lastIndex = steps?.length ? steps.length - 1 : -1;

  if (loading) {
    return <p className="odv2-historico-hint">Carregando histórico…</p>;
  }
  if (error) {
    return <p className="odv2-historico-error">{error}</p>;
  }
  if (!steps?.length) {
    return <p className="odv2-historico-hint">Nenhum registro no histórico do processo.</p>;
  }

  const selectedStep = selectedIndex != null ? steps[selectedIndex] : null;
  const obsText =
    selectedStep == null ? null : selectedStep.TB02130_OBS?.trim() || 'Não há observações.';

  return (
    <div className="odv2-historico">
      <div className="odv2-historico-track-wrap">
        <ol className="odv2-historico-track" aria-label="Histórico do processo">
          {steps.map((step, index) => {
            const isCurrent = index === lastIndex;
            const isSelected = selectedIndex === index;
            const isLast = index === lastIndex;
            const lineTone = isCurrent ? '#0f172a' : '#e2e8f0';

            return (
              <li
                key={`${step.TB02130_NOME}-${index}`}
                className={`odv2-historico-step${isCurrent ? ' odv2-historico-step--current' : ''}${isSelected ? ' odv2-historico-step--selected' : ''}`}
              >
                {!isLast ? (
                  <span
                    className="odv2-historico-connector"
                    style={{ backgroundColor: lineTone }}
                    aria-hidden
                  />
                ) : null}
                <button
                  type="button"
                  className="odv2-historico-step-btn"
                  onClick={() => setSelectedIndex(index)}
                  aria-pressed={isSelected}
                >
                  <span className="odv2-historico-dot-wrap">
                    <HistoricoStepDot isCurrent={isCurrent} />
                  </span>
                  <div className="odv2-historico-step-body">
                    {isCurrent ? (
                      <div className="odv2-historico-current-box">
                        <span className="odv2-historico-status">{step.TB02130_NOME || '—'}</span>
                        <span className="odv2-historico-date">
                          {formatReincidenciaDataAbertura(step.TB02130_DATA, true)}
                        </span>
                      </div>
                    ) : (
                      <>
                        <span className="odv2-historico-status">{step.TB02130_NOME || '—'}</span>
                        <span className="odv2-historico-date">
                          {formatReincidenciaDataAbertura(step.TB02130_DATA, true)}
                        </span>
                      </>
                    )}
                  </div>
                </button>
              </li>
            );
          })}
        </ol>
      </div>
      <div
        className={`odv2-historico-obs-area${selectedStep ? ' odv2-historico-obs-area--open' : ''}`}
        aria-live="polite"
      >
        {selectedStep ? (
          <div className="odv2-historico-obs" role="region" aria-label="Observações da etapa">
            <div className="odv2-historico-obs-head">
              <span className="odv2-historico-obs-label">Observações</span>
              <span className="odv2-historico-obs-status">{selectedStep.TB02130_NOME}</span>
            </div>
            <p className="odv2-historico-obs-text">{obsText}</p>
          </div>
        ) : (
          <p className="odv2-historico-obs-placeholder">Clique em uma etapa para ver as observações.</p>
        )}
      </div>
    </div>
  );
}
